import React from 'react';
import PdfHighlightViewer from './PdfHighlightViewer';

const FileRenderer = ({
  src,
  fileType = '',
  highlights,
  onHighlightsChange,
  enableAnnotations = false
}) => {
  if (fileType.includes('image')) {
    return (
      <img
        className="m-auto"
        alt=""
        style={{
          position: 'absolute',
          border: 'none',
          maxWidth: '100%',
          maxHeight: '100%',
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }}
        src={src}
      />
    );
  }

  // Annotation toolbar/viewer when enabled; otherwise native PDF iframe for select/copy.
  if (fileType.includes('pdf') && enableAnnotations) {
    return (
      <div
        style={{
          position: 'absolute',
          border: 'none',
          width: '100%',
          height: '100%',
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }}
      >
        <PdfHighlightViewer
          src={src}
          highlights={highlights}
          onHighlightsChange={onHighlightsChange}
          enableAnnotations={enableAnnotations}
        />
      </div>
    );
  }

  return (
    <iframe
      allowFullScreen={true}
      className=""
      title="file-preview"
      style={{
        position: 'absolute',
        border: 'none',
        width: '100%',
        height: '100%',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        colorScheme: 'normal'
      }}
      src={src}
    ></iframe>
  );
};

export default FileRenderer;
